// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-290f69a2] {\n  margin-left: 0;\n}\n@media screen and (min-width: 640px) {\n.actions[data-v-290f69a2] {\n    margin-left: auto;\n}\n}", ""]);
// Exports
module.exports = exports;
